const getApiBaseUrl = () => {
  // 1. Check if explicitly defined in build environment (Best Practice)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // 2. Local Development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:3001";
  }

  // 3. Fallback Production URL (Update this if your backend URL changes!)
  return "https://backend-nine-delta-46.vercel.app";
};

export const API_BASE_URL = getApiBaseUrl();

export const CHAT_API_BASE_URL = (() => {
  // Allows running chat backend separately from the main backend
  if (process.env.REACT_APP_CHAT_API_BASE_URL) {
    return process.env.REACT_APP_CHAT_API_BASE_URL;
  }

  // In development, default to local Flask server even if frontend is opened via LAN IP
  if (process.env.NODE_ENV !== 'production') {
    return "http://localhost:5001";
  }

  // Default to local Flask server port
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:5001";
  }

  // Fallback: if you deploy chat behind the same backend, this will still work
  return API_BASE_URL;
})();
